import {
  Box,
  Button,
  Group,
  Image,
  Loader,
  ScrollArea,
  Space,
  Stack,
  Text,
  rem,
} from "@mantine/core";
import { IconArrowLeft, IconBinary } from "@tabler/icons-react";
import useMeterPayload from "../../hooks/useMeterPayload";
import { MeterReturnType } from "../../types";
import { useSessionStore } from "../../store/session.store";
import { ROLES } from "../../constants";
import { useState } from "react";

type MeterDataViewProps = {
  meter: MeterReturnType;
};

export default function MeterDataView({ meter }: MeterDataViewProps) {
  const user = useSessionStore((state) => state.user);
  const { loading, payloadDetails, goBack } = useMeterPayload();

  const [showPayload, setShowPayload] = useState(false);

  const meterStats = [
    {
      label: "Alarms",
      value: payloadDetails?.alarmSummary || "None",
      isAlarm: !!payloadDetails?.alarmSummary,
    },
    {
      label: "Signal strength Indicator",
      value: payloadDetails?.SignalStrengthIndicator,
    },
    {
      label: "Failed Transmissions",
      value: payloadDetails?.TOTAL_FAILED_TRANSMISSIONS,
    },
    {
      label: "Requests to Server",
      value: payloadDetails?.TOTAL_SENT_TO_SERVERS,
    },
    {
      label: "OK server responses",
      value: payloadDetails?.TOTAL_OK_SERVER_RESPONSES,
    },
    {
      label: "NB-iot coverage",
      value: payloadDetails?.NBIOT_COVERAGE_LEVEL,
    },
    {
      label: "Transmission Credits",
      value: payloadDetails?.CURRENT_COMM_CREDIT,
    },
    {
      label: "Consumed Credits",
      value: payloadDetails?.TOTAL_CONSUMED_CREDIT,
    },
  ];

  return (
    <Box>
      <Button
        variant="outline"
        color="black"
        size="xs"
        leftSection={<IconArrowLeft size={16} stroke={1.5} />}
        onClick={goBack}
        radius={8}
        fw={500}
      >
        Back
      </Button>
      <Space h={5} />
      <Group justify="space-between">
        <Image
          src={"../assets/images/tap-icon.png"}
          alt="tap"
          width={50}
          height={50}
        />

        <Text c={"#5a5a5a"} fw={600} size="md">
          M/s: {meter?.meterSerialNo}
        </Text>
      </Group>
      <Space h="lg" />
      <Stack>
        {user?.designation?.toLowerCase() === ROLES.ADMIN?.toLowerCase() &&
        payloadDetails ? (
          <Group>
            <IconBinary />
            <Button
              size="xs"
              variant="outline"
              color="black"
              onClick={() => {
                setShowPayload(!showPayload);
              }}
              w={rem(120)}
              fw={400}
              disabled={loading}
            >
              Payload
            </Button>
          </Group>
        ) : null}
      </Stack>
      {loading ? (
        <Group justify="center" my={"xl"}>
          <Loader size={"sm"} />
          <Text>Loading...</Text>
        </Group>
      ) : (
        <ScrollArea h={"80vh"}>
          {showPayload ? (
            <>
              <Space h="lg" />
              <Box>
                <Text c="#03045e" size="lg" fw={800}>
                  Payload
                </Text>
                <Space h={5} />
                <Text
                  style={{
                    wordBreak: "break-word",
                  }}
                  fw={500}
                >
                  {payloadDetails?.payload}
                </Text>
              </Box>
            </>
          ) : null}
          {payloadDetails && (
            <>
              <Space h="lg" />
              <Box>
                <Text c="#03045e" size="lg" fw={800}>
                  Stats
                </Text>
                <Space h={5} />
                <Stack gap={"sm"}>
                  {meterStats?.map((stat) => (
                    <Group key={stat.label}>
                      <Text size="md" flex={0.6} fw={500}>
                        {stat?.label}:{" "}
                      </Text>
                      <Text
                        size="md"
                        flex={0.4}
                        fw={500}
                        c={(stat as any)?.isAlarm ? "red" : undefined}
                      >
                        {stat?.value}
                      </Text>
                    </Group>
                  ))}
                </Stack>
              </Box>
            </>
          )}
        </ScrollArea>
      )}
    </Box>
  );
}
